/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const KibanaSvg = () => (
  <svg width="17" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M18.375 0H1.96875V7.875C4.80703 7.875 7.47141 8.60541 9.79978 9.87459L18.375 0Z" fill="#F04E98"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M1.96875 7.875V18.8921L9.79978 9.87459C7.47141 8.60541 4.80703 7.875 1.96875 7.875Z" fill="#343741"/>
    <mask id="mask0_1441_5199" maskUnits="userSpaceOnUse" x="2" y="10" width="17" height="11">
      <path d="M2.74609 10.9297H18.0459V21H2.74609V10.9297Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_1441_5199)">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.4913 10.9297L3.4555 20.1841L2.74609 21.0005H18.0459C17.2066 16.8635 14.8053 13.2981 11.4913 10.9297Z" fill="#00BFB3"/>
    </g>
  </svg>

);

export const KibanaIcon = props => <Icon component={KibanaSvg} {...props} />;
